import React, { useEffect } from 'react';

/* import { i18n } from 'language/i18n'; */

const LoginFooter = () => {
  /*  const [currentLanguage, setCurrentLanguage] = useState('tr'); */

  useEffect(() => {
    // setCurrentLanguage(i18n.language);
  }, []);

  return (
    <div className="im-login-footer mb-5">
      <div className="container p-0">
        <div className="row no-gutters">
          {/* <div className="col">
            <select
              className="im-select-blank js-language-select"
              name="Language"
              onChange={(event) => {
                i18n.changeLanguage(event.target.value);
              }}
            >
              <option value="">Seçiniz</option>
              <option selected={currentLanguage === 'tr'} value="tr">Türkçe</option>
              <option selected={currentLanguage === 'en'} value="en">İngilizce</option>
            </select>
          </div> */}
          <div className="col text-right">
            <nav className="horizontal-links">
              <a>Yardım</a>
              <a>Gizlilik</a>
              <a>Şartlar</a>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginFooter;
